/**
 * Capa de obra.
 *
 * Quando o livro tem capa real (`coverBase64`, que o admin já cadastra),
 * é ela que aparece. Sem capa, o fallback não é uma caixa branca vazia:
 * é uma capa tipográfica de verdade — gradiente profundo no hue da
 * edição, moldura interna, brilho diagonal e o título em Gilroy Heavy.
 *
 * O título vai em caixa alta pesada, não em serifada fina: a versão
 * discreta foi testada e reprovada por parecer minimalista demais.
 */
export const BookCover = ({
  titulo,
  autor,
  etiqueta,
  capaBase64,
  className = '',
}) => {
  if (capaBase64) {
    return (
      <div
        className={`relative overflow-hidden rounded-[3px] shadow-[0_30px_56px_-24px_rgba(0,0,0,.45)] ${className}`}
      >
        <img
          src={
            capaBase64.startsWith('data:')
              ? capaBase64
              : `data:image/jpeg;base64,${capaBase64}`
          }
          alt={`Capa de ${titulo}`}
          className="block aspect-[2/3] w-full object-cover"
          loading="lazy"
          decoding="async"
        />
      </div>
    );
  }

  return (
    <div
      className={`relative aspect-[2/3] rounded-[3px] p-3 ${className}`}
      style={{
        background:
          'linear-gradient(158deg, var(--hue-fill) 0%, color-mix(in srgb, var(--hue-fill) 52%, #180a10) 100%)',
        boxShadow:
          '0 30px 56px -24px color-mix(in srgb, var(--hue-fill) 60%, rgba(0,0,0,.6)), 0 2px 8px rgba(0,0,0,.14)',
      }}
      role="img"
      aria-label={autor ? `${titulo}, de ${autor}` : titulo}
    >
      {/* moldura interna */}
      <span
        className="pointer-events-none absolute inset-[11px] border border-white/35"
        aria-hidden="true"
      />
      {/* brilho diagonal: tira o aspecto de retângulo chapado */}
      <span
        className="pointer-events-none absolute inset-0 rounded-[3px]"
        aria-hidden="true"
        style={{
          background:
            'linear-gradient(118deg, rgba(255,255,255,.2) 0%, rgba(255,255,255,0) 42%, rgba(0,0,0,.16) 100%)',
        }}
      />

      <div className="relative grid h-full grid-rows-[auto_1fr_auto] gap-2.5 px-4 py-5 text-center">
        <span className="text-[8.5px] font-bold uppercase tracking-[0.24em] text-white/70">
          {etiqueta}
        </span>

        <div className="grid content-center gap-3">
          <p className="type-club m-0 text-[clamp(17px,2.2vw,28px)] text-white">
            {titulo}
          </p>
          <span
            className="h-0.5 w-7 justify-self-center bg-white/60"
            aria-hidden="true"
          />
          {autor && (
            <span className="text-[9px] font-bold uppercase tracking-[0.17em] text-white/85">
              {autor}
            </span>
          )}
        </div>

        <span className="text-[8px] uppercase tracking-[0.12em] text-white/40">
          Lily Book Club
        </span>
      </div>
    </div>
  );
};

export default BookCover;
